// extracted by mini-css-extract-plugin
export var body = "_ig-5";
export var closeButton = "_ig-f";
export var container = "_ig-1";
export var content = "_ig-2";
export var cta = "_ig-c";
export var ctaLabel = "_ig-b";
export var eyebrow = "_ig-3";
export var howTo = "_ig-6";
export var image = "_ig-e";
export var modal = "_ig-0";
export var socialButton = "_ig-d";
export var stepCard = "_ig-8";
export var stepLabel = "_ig-a";
export var stepNumber = "_ig-9";
export var steps = "_ig-7";
export var title = "_ig-4";